import React from 'react'
import PropTypes from 'prop-types'
import { useToasts } from 'react-toast-notifications'
import eventApi from '_api/event'
import { USER_BLOCK_FEATURE_STATUS_SENT } from '../../../utils/constant'

const UpdatesPopup = ({ isOpen, onClose, blockStatus, onBlockStatusChange }) => {
  const { addToast } = useToasts()

  if (!isOpen) return null

  const handleSendRequest = async () => {
    try {
      const { msgResp } = await eventApi.createRequestCreateEvent()
      addToast(msgResp || 'Request sent successfully!', { appearance: 'success', autoDismiss: true })
      onBlockStatusChange(USER_BLOCK_FEATURE_STATUS_SENT)
      onClose()
    } catch (error) {
      addToast(error?.msgResp || 'Failed to send request. Please try again.', { appearance: 'error', autoDismiss: true })
    }
  }

  return (
    <div className='updates-popup-overlay'>
      <div className='updates-popup'>
        <div className='updates-popup__header' style={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr', alignItems: 'center' }}>
          <div></div>
          <span style={{ fontWeight: 'bold', fontSize: '16px', textAlign: 'center' }}>Updates</span>
          <span onClick={onClose} style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: '16px', justifySelf: 'end' }}>✕</span>
        </div>
        <div className='updates-popup__content'>
          <p>
            Your event creation feature has been disabled because your group has not created any events in the past{' '}
            <strong>six months</strong>.
          </p>
          <p>
            To reactivate it, please submit a request to the administrator.
            Once approved, the Host feature will be re-enabled.
          </p>
          <p>
            If you have already sent a request, please wait for the admin to approve it.
          </p>
          <p>
            Thank you for being part of the Co-bee community 💛
          </p>
        </div>
        <div className='updates-popup__footer'>
          <button
            className={`updates-popup__close-btn ${blockStatus === USER_BLOCK_FEATURE_STATUS_SENT ? 'disabled' : ''}`}
            onClick={handleSendRequest}
            disabled={blockStatus === USER_BLOCK_FEATURE_STATUS_SENT}
          >
            {blockStatus === USER_BLOCK_FEATURE_STATUS_SENT ? 'Request has been submitted.' : 'Request to create event'}
          </button>
        </div>
      </div>
    </div>
  )
}

UpdatesPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  blockStatus: PropTypes.string,
  onBlockStatusChange: PropTypes.func.isRequired,
}

export default UpdatesPopup
